
ADILF.define('less/less!adilf/apps/profile/css/styles',[],function(){});